"use strict";
import { NATIVE_CHAIN_ID } from "constants/tokens";
import { supportedChainIdFromGQLChain } from "graphql/data/util";
import { TokenStandard } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
export function buildCurrencyKey(chainId, address) {
  return `${chainId}-${address.toLowerCase()}`;
}
export function currencyKey(currency) {
  return buildCurrencyKey(currency.chainId, currency.isToken ? currency.address : NATIVE_CHAIN_ID);
}
export function currencyKeyFromGraphQL(contract) {
  const chainId = supportedChainIdFromGQLChain(contract.chain);
  const address = contract.standard === TokenStandard.Native ? NATIVE_CHAIN_ID : contract.address;
  if (!address) {
    throw new Error("Non-native token missing address");
  }
  if (!chainId) {
    throw new Error("Unsupported chain from pools query");
  }
  return buildCurrencyKey(chainId, address);
}
